import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Switch,
  Tooltip,
} from "@material-ui/core";

import { PlaylistAddOutlined, Shuffle } from "@material-ui/icons";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useProdutoController from "../controllers/ProdutoController";
import { ProdutoContext } from "../contexts/ProdutoContext";
import CardProdutoCustoPreco from "./CardProdutoCustoPreco";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import ModalProdutoCodigoBarraAdicional from "./ModalProdutoCodigoBarraAdicional";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";
import CardProdutoLocalizacao from "./CardProdutoLocalizacao";
import { Margin } from "../../../../theme/styles/Utils";
import { findProdutos } from "../../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import Swal from "sweetalert2";

export default function ModalProdutoLocalEstoque({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
  ableToRegister,
  mainProductId,
}) {
  const {
    loadingInputs,
    stockLocations,
    setStockLocations,
    mainBarCode,
    listStockLocations,
    barCodeAdditionalModal,
    setBarCodeAdditionalModal,
    setLoading,
    mainActive,
    setMainActive,
  } = useContext(ProdutoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { handleCreateBarCode, removeMaskDecimal } = useProdutoController();

  const [updatedList, setUpdatedList] = useState([]);

  const [stockLocationModal, setStockLocationModal] = useState(null);
  const [stockMinModal, setStockMinModal] = useState("0,00");
  const [stockMaxModal, setStockMaxModal] = useState("0,00");
  const [hallModal, setHallModal] = useState("");
  const [stockDescription, setStockDescription] = useState("");
  const [hallwayModal, setHallwayModal] = useState("");
  const [shelfModal, setShelfModal] = useState("");
  const [boxModal, setBoxModal] = useState("");
  const [alertSaleModal, setAlertSaleModal] = useState("");
  const [codeIntegrationModal, setCodeIntegrationModal] = useState("");
  const [consultationPriceModal, setConsultationPriceModal] = useState(false);
  const [exposedPriceModal, setExposedPriceModal] = useState(false);
  const [displayStockModal, setDisplayStockModal] = useState(false);
  const [activeModal, setActiveModal] = useState(mainActive);
  const [stockId, setStockId] = useState(0);

  //Códigos de Barras
  const [openBarCodeAdd, setOpenBarCodeAdd] = useState(false);
  const [barCodeModal, setBarCodeModal] = useState("");

  //Card Custos
  const [grossCost, setGrossCost] = useState("0,00000");
  const [realCost, setRealCost] = useState("0,00000");
  const [salesMargin, setSalesMargin] = useState("0,00000");
  const [wholeSalesMargin, setWholeSalesMargin] = useState("0,00");
  const [salePrice, setSalePrice] = useState("0,00");
  const [taxPrice, setTaxPrice] = useState("0,00");
  const [salePriceAux, setSalePriceAux] = useState("0,00000");
  const [freightValue, setFreightValue] = useState("0,00000");
  const [freightPercentage, setFreightPercentage] = useState("0,00000");
  const [insuranceValue, setInsuranceValue] = useState("0,00000");
  const [insurancePercentage, setInsurancePercentage] = useState("0,00000");
  const [discountValue, setDiscountValue] = useState("0,00000");
  const [discountPercentage, setDiscountPercentage] = useState("0,00000");
  const [othersValue, setOthersValue] = useState("0,00000");
  const [othersPercentage, setOthersPercentage] = useState("0,00000");
  const [icmsStValue, setIcmsStValue] = useState("0,00000");
  const [icmsStPercentage, setIcmsStPercentage] = useState("0,00000");
  const [ipiValue, setIpiValue] = useState("0,00000");
  const [ipiPercentage, setIpiPercentage] = useState("0,00000");
  const [pisValue, setPisValue] = useState("0,00000");
  const [pisPercentage, setPisPercentage] = useState("0,00000");
  const [cofinsValue, setCofinsValue] = useState("0,00000");
  const [cofinsPercentage, setCofinsPercentage] = useState("0,00000");
  const [errorsModal, setErrorsModal] = useState({});
  const [wholesaleValue, setWholesaleValue] = useState("0,00");
  const [fixedPrice, setFixedPrice] = useState(false);

  const valuesSettersCard = {
    grossCost,
    setGrossCost,
    realCost,
    setRealCost,
    salesMargin,
    setSalesMargin,
    wholeSalesMargin,
    setWholeSalesMargin,
    salePrice,
    setSalePrice,
    taxPrice,
    setTaxPrice,
    freightValue,
    setFreightValue,
    freightPercentage,
    setFreightPercentage,
    insuranceValue,
    setInsuranceValue,
    insurancePercentage,
    setInsurancePercentage,
    discountValue,
    setDiscountValue,
    discountPercentage,
    setDiscountPercentage,
    othersValue,
    setOthersValue,
    othersPercentage,
    setOthersPercentage,
    icmsStValue,
    setIcmsStValue,
    icmsStPercentage,
    setIcmsStPercentage,
    ipiValue,
    setIpiValue,
    ipiPercentage,
    setIpiPercentage,
    pisValue,
    setPisValue,
    pisPercentage,
    setPisPercentage,
    cofinsValue,
    setCofinsValue,
    cofinsPercentage,
    setCofinsPercentage,
    wholesaleValue,
    setWholesaleValue,
    salePriceAux,
    setSalePriceAux,
    fixedPrice,
    setFixedPrice,
  };

  const locationSettersCard = {
    hallModal,
    setHallModal,
    hallwayModal,
    setHallwayModal,
    shelfModal,
    setShelfModal,
    boxModal,
    setBoxModal,
  };

  const barCodeOnStock =
    queryParams.permitecodigobarrasadicionais === "SIM" &&
    queryParams.codigobarraslocalestoque === "SIM";

  useEffect(() => {
    if (rowEdit) ableToRegister.push(rowEdit.data.idlocalestoque);

    let newUpdatedList = listStockLocations.filter((listItem) =>
      ableToRegister.includes(listItem.id)
    );

    const uniqueStockLocation = newUpdatedList.find(
      (stockLocation) => stockLocation.descricao === "UNICO"
    );

    setUpdatedList(newUpdatedList);
    setStockLocationModal(uniqueStockLocation ?? newUpdatedList[0]);
    setStockDescription(uniqueStockLocation?.descricao ?? "");
  }, [listStockLocations, ableToRegister, rowEdit]);

  useEffect(() => {
    if (!rowEdit?.data) return;

    const { data } = rowEdit;

    if (!stockLocationModal) {
      setStockLocationModal(
        updatedList.find((e) => e.id === data.idlocalestoque)
      );
    }
  }, [rowEdit, stockLocationModal, updatedList]);

  useEffect(() => {
    if (!rowEdit?.data) return;

    const { data } = rowEdit;

    const editingStockLocation = listStockLocations.find(
      (e) => e.id === data.idlocalestoque
    );

    setStockLocationModal(editingStockLocation);
    setStockId(data.id ?? 0);

    setStockMinModal(
      MaskService.toMask(
        "decimal",
        data.qtdeminima ? parseFloat(data.qtdeminima).toFixed(2) : "0.00"
      )
    );
    setStockMaxModal(
      MaskService.toMask(
        "decimal",
        data.qtdemaxima ? parseFloat(data.qtdemaxima).toFixed(2) : "0.00"
      )
    );
    setHallModal(data.salao || "");
    setStockDescription(data.descricao || "");
    setHallwayModal(data.corredor || "");
    setShelfModal(data.prateleira || "");
    setBoxModal(data.box || "");
    setCodeIntegrationModal(data.codigointegracao || "");
    setConsultationPriceModal(data.sobconsulta === "S");
    setExposedPriceModal(data.exposto === "S");
    setDisplayStockModal(data.exibir_estoque === "S");
    setActiveModal(data.inativo === "N");
    setFixedPrice(data.precofixo === "SIM");
    setAlertSaleModal(data.observacao || "");

    if (queryParams.codigobarraslocalestoque === "SIM") {
      setBarCodeModal(data.codigobarras || "");

      if (queryParams.permitecodigobarrasadicionais === "SIM")
        setBarCodeAdditionalModal(data.codigosbarrasalternativos ?? []);
    }

    const getFixedParseFloat = (value, fractionDigits) => {
      return (!isNaN(parseFloat(value)) ? parseFloat(value) : 0).toFixed(
        fractionDigits
      );
    };

    if (queryParams.paramprecoestoqueunico === "NAO") {
      setGrossCost(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.custobruto ?? data?.precovenda, 5),
          5
        )
      );
      setRealCost(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.custobruto, 5),
          5
        )
      );
      setSalesMargin(
        MaskService.toMask("decimal", getFixedParseFloat(data?.porcfixo, 5), 5)
      );
      setWholeSalesMargin(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.atacado_porc, 2),
          2
        )
      );
      setSalePrice(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.precovenda, 2),
          2
        )
      );
      setTaxPrice(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.valor_tributavel, 2),
          2
        )
      );
      setSalePriceAux(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.precovenda, 5),
          5
        )
      );
      setFreightValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.frete, 5), 5)
      );
      setFreightPercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.frete_porc, 5),
          5
        )
      );
      setInsuranceValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.seguro, 5), 5)
      );
      setInsurancePercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.seguro_porc, 5),
          5
        )
      );
      setDiscountValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.desconto, 5), 5)
      );
      setDiscountPercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.desconto_porc, 5),
          5
        )
      );
      setOthersValue(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.outrasdesp, 5),
          5
        )
      );
      setOthersPercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.outrasdesp_porc, 5),
          5
        )
      );
      setIcmsStValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.icmsst, 5), 5)
      );
      setIcmsStPercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.icmsst_porc, 5),
          5
        )
      );
      setIpiValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.ipi, 5), 5)
      );
      setIpiPercentage(
        MaskService.toMask("decimal", getFixedParseFloat(data?.ipi_porc, 5), 5)
      );
      setPisValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.pis, 5), 5)
      );
      setPisPercentage(
        MaskService.toMask("decimal", getFixedParseFloat(data?.pis_porc, 5), 5)
      );
      setCofinsValue(
        MaskService.toMask("decimal", getFixedParseFloat(data?.cofins, 5), 5)
      );
      setCofinsPercentage(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.cofins_porc, 5),
          5
        )
      );
      setWholesaleValue(
        MaskService.toMask(
          "decimal",
          getFixedParseFloat(data?.precoatacado, 2),
          2
        )
      );
    }
  }, [
    rowEdit,
    listStockLocations,
    queryParams.codigobarraslocalestoque,
    queryParams.paramprecoestoqueunico,
    queryParams.permitecodigobarrasadicionais,
    setBarCodeAdditionalModal,
  ]);

  useEffect(() => {
    if (mainProductId && !activeModal && mainActive) {
      setLoading(true);
      (async () => {
        try {
          const checkStock = await findProdutos({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: mainProductId,
            include: "estoques",
          });
          if (checkStock.success) {
            const rowStock = checkStock.data.estoques.find(
              (current) =>
                current.idlocalestoque === rowEdit?.data?.idlocalestoque
            );
            if (rowStock && Number(rowStock.qtdeatual) > 0) {
              setActiveModal(true);
              return notify(
                "Local de Estoque com saldo, não pode ser inativado."
              );
            }
          }
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [
    activeModal,
    mainProductId,
    queryParams.empresa_cnpj,
    rowEdit,
    setLoading,
    mainActive,
  ]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handlesStockLocation = (value) => {
    setStockLocationModal(value ?? null);
    setStockDescription(value?.descricao ?? "");
  };

  const handleAdd = () => {
    const validationInput = validNotNull([
      { key: "stockLocationModal", value: stockLocationModal },
    ]);

    setErrorsModal({
      ...validationInput.errorsValidation,
      accordionInput: validationInput.error,
    });
    if (validationInput.error) {
      return notify(
        "Verifique se os campos Obrigatorios estão preenchidos corretamente."
      );
    }

    if (queryParams.codigobarraslocalestoque === "SIM") {
      let repeatedCode = false;

      stockLocations.forEach((stock) => {
        if (
          stock.codigobarras === barCodeModal &&
          stock.idlocalestoque !== stockLocationModal.id
        ) {
          if (
            rowEdit &&
            rowEdit?.data?.idlocalestoque !== stockLocationModal.id
          )
            repeatedCode = false;
          else repeatedCode = true;
        }
      });

      if (repeatedCode) {
        setErrorsModal({ barCodeModal: "Código repetido" });
        return notify(
          "Código de barras já utilizado em outro local de estoque."
        );
      }
    }

    let body = {
      idlocalestoque: stockLocationModal.id,
      descricao: stockDescription || stockLocationModal.descricao,
      qtdeminima: removeMaskDecimal(stockMinModal),
      qtdemaxima: removeMaskDecimal(stockMaxModal),
      porcfixo: removeMaskDecimal(salesMargin, 5),
      precovenda: removeMaskDecimal(salePrice),
      corredor: hallwayModal, //50
      prateleira: shelfModal, //50
      box: boxModal, //50
      inativo: activeModal ? "N" : "S",
      sobconsulta: consultationPriceModal ? "S" : "N",
      exibir_estoque: displayStockModal ? "S" : "N",
      salao: hallModal, //50
      exposto: exposedPriceModal ? "S" : "N",
      codigointegracao: codeIntegrationModal,
      precoultimacompra: removeMaskDecimal(realCost, 5),
      observacao: alertSaleModal,
      valor_tributavel: removeMaskDecimal(taxPrice),
      // idtipotamanho: sizesModal,
      // idtipocor: colorsModal,
      // precocustosemdescontos: //10,2
      // precofixo:    //3 max
    };

    if (queryParams.permiteprecofixo === "SIM") {
      body = {
        ...body,
        precofixo: fixedPrice ? "SIM" : "NAO",
      };
    }

    if (queryParams.paramutilizavarejoatacado === "SIM") {
      body = {
        ...body,
        atacado_porc: removeMaskDecimal(wholeSalesMargin),
        precoatacado: removeMaskDecimal(wholesaleValue),
      };
    }

    if (queryParams.codigobarraslocalestoque === "SIM") {
      body = {
        ...body,
        codigobarras: barCodeModal.replaceAll(" ", ""), //20
      };
      if (queryParams.permitecodigobarrasadicionais === "SIM") {
        body = {
          ...body,
          codigosbarrasalternativos: barCodeAdditionalModal,
        };
      }
    } else {
      body = {
        ...body,
        codigobarras: mainBarCode.replaceAll(" ", ""),
      };
    }

    if (queryParams.paramprecoestoqueunico !== "SIM") {
      body = {
        ...body,
        custobruto:
          grossCost !== "0,00000"
            ? removeMaskDecimal(grossCost, 5)
            : removeMaskDecimal(salePrice, 5),
        frete: removeMaskDecimal(freightValue, 5),
        frete_porc: removeMaskDecimal(freightPercentage, 5),
        seguro: removeMaskDecimal(insuranceValue, 5),
        seguro_porc: removeMaskDecimal(insurancePercentage, 5),
        desconto: removeMaskDecimal(discountValue, 5),
        desconto_porc: removeMaskDecimal(discountPercentage, 5),
        outrasdesp: removeMaskDecimal(othersValue, 5),
        outrasdesp_porc: removeMaskDecimal(othersPercentage, 5),
        icmsst: removeMaskDecimal(icmsStValue, 5),
        icmsst_porc: removeMaskDecimal(icmsStPercentage, 5),
        ipi: removeMaskDecimal(ipiValue, 5),
        ipi_porc: removeMaskDecimal(ipiPercentage, 5),
        pis: removeMaskDecimal(pisValue, 5),
        pis_porc: removeMaskDecimal(pisPercentage, 5),
        cofins: removeMaskDecimal(cofinsValue, 5),
        cofins_porc: removeMaskDecimal(cofinsPercentage, 5),
      };
    }

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...stockLocations];
        copy[rowEdit.index] = body;

        if (
          !copy.filter((current) => current.inativo !== "S").length &&
          mainActive
        ) {
          Swal.fire({
            icon: "question",
            text: "Todos os locais de estoque estão inativos. Deseja inativar o produto?",
            showConfirmButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              setMainActive(false);
              notify(
                "Produto inativado, não possui local de estoque ativo",
                true,
                "success"
              );
            }
          });
        }

        setStockLocations(copy);
      }
    } else {
      setStockLocations((current) => [...current, body]);
    }

    const uniqueStockLocation =
      listStockLocations.find(
        (stockLocation) => stockLocation.descricao === "UNICO"
      ) || listStockLocations[0];

    setStockLocationModal(uniqueStockLocation ?? null);
    setStockMinModal("");
    setStockMaxModal("");
    setHallModal("");
    setHallwayModal("");
    setShelfModal("");
    setBoxModal("");
    setAlertSaleModal("");
    setCodeIntegrationModal("");
    setConsultationPriceModal(false);
    setExposedPriceModal(false);
    setDisplayStockModal(false);
    setActiveModal(false);
    setOpen(false);
    setStockId(0);
    setBarCodeAdditionalModal([]);
    setRowEdit(null);
    setUpdatedList([]);
  };

  return (
    <>
      <ModalProdutoCodigoBarraAdicional
        open={openBarCodeAdd}
        setOpen={setOpenBarCodeAdd}
        barCodeAdditional={barCodeAdditionalModal}
        setBarCodeAdditional={setBarCodeAdditionalModal}
        idestoque={stockId ?? null}
        barCodeFromModal={barCodeModal}
      />
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Local de Estoque
          {rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {barCodeOnStock && (
              <>
                <Grid item lg={3} md={4} sm={6} xs={12}>
                  <TextFieldErp
                    error={
                      errorsModal.barCodeModal || !!rowEdit?.data?.barCodeError
                        ? true
                        : false
                    }
                    helperText={
                      errorsModal.barCodeModal ||
                      (!!rowEdit?.data?.barCodeError && "Código repetido") ||
                      ""
                    }
                    label="Código de Barras"
                    maxLength={20}
                    value={barCodeModal}
                    setValue={setBarCodeModal}
                  />
                </Grid>

                <Tooltip title="Gerar Código">
                  <Grid item flex={1}>
                    <Btn
                      label={<Shuffle />}
                      bgcolor="tertiary"
                      onClick={() => handleCreateBarCode(setBarCodeModal)}
                    />
                  </Grid>
                </Tooltip>

                {queryParams.permitecodigobarrasadicionais === "SIM" && (
                  <Tooltip title="Código Adicional">
                    <Grid item flex={1}>
                      <Btn
                        label={<PlaylistAddOutlined />}
                        bgcolor={
                          rowEdit?.data?.additionalCodeError
                            ? "red"
                            : "tertiary"
                        }
                        onClick={() => setOpenBarCodeAdd((current) => !current)}
                        // medida paliativa pra nao deixar colocar codigos
                        // adicionais enquanto nao houver idestoque
                        disabled={!stockId}
                      />
                    </Grid>
                  </Tooltip>
                )}
              </>
            )}
            <Grid item md={barCodeOnStock ? 3 : 4} xs={12}>
              <SelectErp
                error={errorsModal.stockLocationModal || false}
                helperText={errorsModal.stockLocationModal || ""}
                loading={loadingInputs.listStockLocations || false}
                label="Local de Estoque"
                value={stockLocationModal}
                setValue={setStockLocationModal}
                optionsList={updatedList}
                descriptionField="descricao"
                onChange={handlesStockLocation}
              />
            </Grid>

            <Grid item sm={4} xs={12}>
              <TextFieldErp
                label="Estoque Mínimo"
                maxLength={60}
                value={stockMinModal}
                setValue={setStockMinModal}
                mask="decimal"
              />
            </Grid>

            <Grid item sm={4} xs={12}>
              <TextFieldErp
                label="Estoque Máximo"
                maxLength={60}
                value={stockMaxModal}
                setValue={setStockMaxModal}
                mask="decimal"
              />
            </Grid>

            <Grid item md={3} sm={6} xs={12}>
              <TextFieldErp
                label="Alerta de faturamento"
                maxLength={50}
                value={alertSaleModal}
                setValue={setAlertSaleModal}
              />
            </Grid>

            {/* Retirado na task QEF-339 */}
            {/* <Grid item md={3} sm={6} xs={12}>
              <TextFieldErp
                label="Código de Integração"
                maxLength={50}
                value={codeIntegrationModal}
                setValue={setCodeIntegrationModal}
              />
            </Grid> */}

            <Grid item flex={1}>
              <FormControlLabel
                control={
                  <Switch
                    checked={consultationPriceModal}
                    onChange={() =>
                      setConsultationPriceModal((current) => !current)
                    }
                    color="primary"
                  />
                }
                label="Preço Sob Consulta"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <FormControlLabel
                control={
                  <Switch
                    checked={exposedPriceModal}
                    onChange={() => setExposedPriceModal((current) => !current)}
                    color="primary"
                  />
                }
                label="Produto Exposto com Preço"
                labelPlacement="end"
              />
            </Grid>
            {queryParams.paramprecoestoqueunico === "NAO" && (
              <Grid item xs={12} md={6} lg={6}>
                <CardProdutoCustoPreco valuesSetters={valuesSettersCard} />
              </Grid>
            )}
            <Grid item xs={12} md={6} lg={6}>
              <CardProdutoLocalizacao valuesSetters={locationSettersCard} />

              <Margin top="10">
                <Grid container item>
                  <Grid item flex={1}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={displayStockModal}
                          onChange={() =>
                            setDisplayStockModal((current) => !current)
                          }
                          color="primary"
                        />
                      }
                      label="Exibir Estoque"
                      labelPlacement="end"
                    />
                  </Grid>

                  <Grid item flex={1}>
                    <Tooltip
                      title={
                        !mainActive
                          ? "Não é possível ativar local de estoque de produto inativo."
                          : ""
                      }
                      arrow
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            checked={activeModal}
                            onChange={() =>
                              setActiveModal((current) => !current)
                            }
                            color="primary"
                            disabled={!mainActive}
                          />
                        }
                        label="Ativo"
                        labelPlacement="end"
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </Margin>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
